export interface EventBookingFileInfo {
  fileName: string;
  fileSizeInBytes: number;
  internalFileId: string;
  mimeType?: string;
  sha256Checksum?: string;
  uploadedAt?: string;
}
